<script>
export default {
    name: "AllThatApplyQuestion",
    data() {
        return {
            selectedOptions: [],
        }
    },
    methods: {
        checkAnswer() {
            this.$emit('checkInput', this.selectedOptions)
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            default: 'Check Answer'
        }
    }
}
</script>

<template>
    <div>
        <div class="quiz-question quiz-question-multiple-choice">
            <div class="form-check"
                 v-for="option in question.questionTypeData.options"
                 :key="option.id"
            >
                <input
                    class="form-check-input"
                    type="checkbox"
                    :name="`question-${question.id}-option-${option.id}`"
                    :value="option.id"
                    :id="`option-${option.id}`"
                    v-model="selectedOptions"
                >
                <label class="form-check-label" :for="`option-${option.id}`">{{ option.answer }}</label>
            </div>
            <button type="button" class="btn btn-secondary mt-3" @click="checkAnswer()">{{ buttonLabel }}</button>
        </div>
    </div>
</template>
